import { Box, Grid, GridItem, Image, Stack, Text } from "@chakra-ui/react";
import { useState } from "react";

import { wrapBgImage } from "@/utilities/helpers/wrapBgImage";

import ModalGallery from "./ModalGallery";

const NoImage = () => {
    return (
        <Stack
            minH="175px"
            h="100%"
            bg="gray.100"
            justifyContent="center"
            _hover={{
                opacity: "0.9",
            }}
            cursor="not-allowed"
        >
            <Box textAlign="center">
                <Image
                    src="https://storage-vision.s3.us-east-2.amazonaws.com/icon/sin-imagen.svg"
                    m="auto"
                    alt="img"
                    boxSize="50px"
                />
                <Text color="#959595" fontSize="md" fontWeight={600}>
                    No image
                </Text>
            </Box>
        </Stack>
    );
};

const GalleryImages = ({ images, koppi, setIsRouteViewer }) => {
    const [idx, setIdx] = useState(0);
    const [isOpen, setIsOpen] = useState(false);

    const onOpen = () => {
        setIsOpen(true);
    };

    const onClose = () => {
        setIsOpen(false);
    };

    const handleOpenModal = (idx) => {
        setIdx(idx);
        onOpen();
    };

    const getImagesToDisplay = (images) => {
        if (!images || images.length === 0) {
            return Array(4).fill(null);
        }

        const displayImages = images.slice(1, 5);
        while (displayImages.length < 4) {
            displayImages.push(null);
        }
        return displayImages;
    };

    const imagesBox = getImagesToDisplay(images);

    return (
        <Stack my={6}>
            <ModalGallery
                isOpen={isOpen}
                onClose={onClose}
                data={images}
                idx={idx}
                setIdx={setIdx}
            />
            {images && (
                <Grid
                    templateColumns={{ base: "repeat(1, 1fr)", md: "repeat(2, 1fr)" }}
                    gap={3}
                    minH="350px"
                >
                    <GridItem colSpan={1} minHeight="350px">
                        {images[0]?.url || typeof images[0] === "string" ? (
                            <Box
                                w="100%"
                                h="100%"
                                position="relative"
                                bgImage={wrapBgImage(
                                    images[0]?.url ? encodeURI(images[0]?.url) : images[0]
                                )}
                                bgSize="cover"
                                bgPosition="center"
                                borderRadius="lg"
                                borderRightRadius={{ base: "lg", md: "none" }}
                                _hover={{
                                    opacity: "0.9",
                                }}
                                cursor="pointer"
                                rounded="lg"
                                onClick={(e) => {
                                    e.preventDefault();
                                    handleOpenModal(0);
                                }}
                            ></Box>
                        ) : (
                            <NoImage />
                        )}
                    </GridItem>
                    <GridItem colSpan={1} display={{ base: "none", md: "block" }}>
                        <Grid
                            templateColumns={{ base: "repeat(1, 1fr)", md: "repeat(2, 1fr)" }}
                            gap={3}
                            minH="350px"
                        >
                            {imagesBox.map((image, idx) => {
                                return (
                                    <GridItem colSpan={1} minH="175px" key={idx}>
                                        {image && (image.url || typeof image === "string") ? (
                                            <Box
                                                w="100%"
                                                h="100%"
                                                bgImage={wrapBgImage(
                                                    image.url ? encodeURI(image.url) : image
                                                )}
                                                bgSize="cover"
                                                bgPosition="center"
                                                borderTopRightRadius={idx === 1 ? "lg" : "none"}
                                                borderBottomRightRadius={idx === 3 ? "lg" : "none"}
                                                overflow="hidden"
                                                _hover={{
                                                    opacity: "0.9",
                                                }}
                                                bgimagequality="low"
                                                cursor="pointer"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    if (
                                                        idx === 1 &&
                                                        koppi?.status === "ACTIVE" &&
                                                        koppi?.url
                                                    ) {
                                                        setIsRouteViewer(true);
                                                    } else {
                                                        handleOpenModal(idx + 1);
                                                    }
                                                }}
                                            >
                                                {idx === 1 && koppi?.status === "ACTIVE" ? (
                                                    <Stack
                                                        h="100%"
                                                        w="100%"
                                                        alignItems="center"
                                                        justifyContent="center"
                                                        bg="#00000066"
                                                    >
                                                        <Box
                                                            color="#FFFFFF"
                                                            textAlign="center"
                                                            py={2}
                                                            px={6}
                                                            justifyItems="center"
                                                            fontSize={{ base: "sm", md: "md" }}
                                                            w="fit-content"
                                                        >
                                                            <Image
                                                                src="https://media.grupoguia.mx/assets/icons/gallery_virtual_route.svg"
                                                                alt="virtual_route"
                                                                maxW="50px"
                                                            />
                                                            <Text>Ver recorrido virtual</Text>
                                                        </Box>
                                                    </Stack>
                                                ) : (
                                                    idx === 3 && (
                                                        <Stack
                                                            h="100%"
                                                            alignItems="center"
                                                            justifyContent="center"
                                                            bg="#00000066"
                                                        >
                                                            <Box>
                                                                <Text
                                                                    color="#002B49"
                                                                    bg="#FFFFFF"
                                                                    textAlign="center"
                                                                    py={2}
                                                                    px={6}
                                                                    w="fit-content"
                                                                    rounded="lg"
                                                                    borderWidth="1px"
                                                                >
                                                                    Ver más Fotos
                                                                </Text>
                                                            </Box>
                                                        </Stack>
                                                    )
                                                )}
                                            </Box>
                                        ) : (
                                            <NoImage />
                                        )}
                                    </GridItem>
                                );
                            })}
                        </Grid>
                    </GridItem>
                </Grid>
            )}
        </Stack>
    );
};

export default GalleryImages;
